import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
export const GET_LEGACY_CBES = registerQuery({
  fieldName: 'legacyCBEs',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('reports/v1/events/simple', {
      query: {
        portalId
      }
    });
  }
});